import { EuiFieldText, EuiFlexGroup, EuiFlexItem, EuiFormRow, EuiText } from "@elastic/eui";
import React, { forwardRef, useEffect, useMemo, useState } from "react";
import { stringToFloat, toDecimalString } from "../../../../../../shared/utils/numbers";


interface FilaAjuste{
    nombre:string;
    costo:number;
    costoCorreccion:number;
    costoTotal:number;
    costoFacturable:number;
    //noFacturable:number;
}

interface Props{
    isLoading:boolean;
    data:FilaAjuste;
    //onSave(facturable:any):any;
    addAjuste(facturable:any):any;
    showLabel?:boolean;
    esUpdate:boolean;
    enabled:boolean;
}

export const FilaAjuste = forwardRef((props:Props,ref:any)=>{

    const {data,addAjuste,showLabel,esUpdate,enabled,isLoading} = props;
    const {nombre,costo,costoCorreccion,costoTotal,costoFacturable} = data;
    
    const [ajusteFacturable, setAjusteFacturable] = useState<string>("0");
    const [ajusteNoFacturable, setAjusteNoFacturable] = useState<string>("0");

    useEffect(()=>{
        if(data!==undefined)
        {
            setAjusteFacturable(toDecimalString(esUpdate === true ? costoFacturable : costoTotal));
        }
    },[data])

    useEffect(()=>{
        const ajusteNumber:number = parseFloat(ajusteFacturable.replace('.','').replace(',','.'));
        const resta = costoTotal - ajusteNumber;
        
        setAjusteNoFacturable(toDecimalString(resta))
    },[ajusteFacturable])

    const onChangeFacturable = (value:string) =>{
        setAjusteFacturable(value)
    }

    const MAXIMO_FACTURABLE = useMemo(() => costoTotal>=0 ? costoTotal : 0,[costoTotal])
    const MINIMO_FACTURABLE = useMemo(() => costoTotal>=0 ? 0 : costoTotal,[costoTotal])

    const isInvalidAjusteFacturableMayor = useMemo(()=>{
        const ajusteNumber:number = parseFloat(ajusteFacturable.replace('.','').replace(',','.'));
        return ajusteNumber>MAXIMO_FACTURABLE

    },[ajusteFacturable,MAXIMO_FACTURABLE])

    const isInvalidAjusteFacturableMenor = useMemo(()=>{
        const ajusteNumber:number = parseFloat(ajusteFacturable.replace('.','').replace(',','.'));
        return ajusteNumber<MINIMO_FACTURABLE
        
    },[ajusteFacturable,MINIMO_FACTURABLE])

    const isInvalidAjusteFacturable = useMemo(()=> isInvalidAjusteFacturableMayor || isInvalidAjusteFacturableMenor,[isInvalidAjusteFacturableMayor, isInvalidAjusteFacturableMenor])

    const getErrorAjusteFacturable = useMemo(()=>{
        const msg = isInvalidAjusteFacturableMayor ? 'mayor' : 'menor';
        if(isInvalidAjusteFacturableMayor || isInvalidAjusteFacturableMenor){
            return (
                <EuiFlexItem style={{alignItems:'flex-end'}}>
                    <p style={{color:'red',fontSize:'small'}}><strong>{`El valor Facturable de ${nombre} no puede ser ${msg} que el valor Total`}</strong></p>
                </EuiFlexItem>
            )
        }else{return null}
    },[isInvalidAjusteFacturableMayor, isInvalidAjusteFacturableMenor])

    const isInvalidAjusteFacturableFormat = useMemo(()=>
        ((ajusteFacturable.slice(-1)===',' || ajusteFacturable.slice(-1)==='.') || 
        (ajusteFacturable.slice(0,1)===',' || ajusteFacturable.slice(0,1)==='.'))
    ,[ajusteFacturable])

    const getErrorFormato = useMemo(()=>{
        if(isInvalidAjusteFacturableFormat===true){
            return (
                <EuiFlexItem style={{alignItems:'flex-end'}}>
                    <p style={{color:'red',fontSize:'small'}}><strong>{`El formato introducido no es correcto`}</strong></p>
                </EuiFlexItem>
            )
        }else{return null}
    },[isInvalidAjusteFacturableFormat])

    const onBlurFacturable = (e:any)=>{
        if(isInvalidAjusteFacturableFormat){
            let element = document.getElementById(e.target.id)
            if(element){element.focus();}
        }
        else{  
            let ajusteNumber = (ajusteFacturable === '' || isNaN((parseFloat(ajusteFacturable)))) ? costoTotal : parseFloat(ajusteFacturable.replace('.','').replace(',','.'));
            setAjusteFacturable(toDecimalString(ajusteNumber))
            addAjuste({[`${nombre}_Ajuste`]:ajusteNumber})
        }
    }

    const divisaRender = useMemo(()=>(<EuiText size="m">€</EuiText>),[])

    return(
        <EuiFlexGroup direction="column" gutterSize="m">
            <EuiFlexItem>
                <EuiFlexGroup justifyContent="center">
                
                        <EuiFlexItem style={{width:'150px', textAlign:'right'}}>
                            <EuiFormRow hasEmptyLabelSpace={true}>
                                <span>{nombre}</span>
                            </EuiFormRow>
                        </EuiFlexItem>
                        <EuiFlexItem className="txt-ajuste-expatriados">
                            <EuiFormRow label={showLabel ? 'Mensual' : ''} hasEmptyLabelSpace={showLabel===true?false:true}>
                                <EuiFieldText className="txt-ajuste-expatriados" isLoading={isLoading} compressed readOnly 
                                tabIndex={-1} value={isLoading?'0.00':toDecimalString(costo)} append={divisaRender}/>
                            </EuiFormRow>
                        </EuiFlexItem>
                        <EuiFlexItem className="txt-ajuste-expatriados">
                            <EuiFormRow label={showLabel?'Correción':''} hasEmptyLabelSpace={showLabel===true?false:true}>
                                <EuiFieldText className="txt-ajuste-expatriados" isLoading={isLoading} compressed readOnly 
                                tabIndex={-1} value={isLoading?'0.00':toDecimalString(costoCorreccion)} append={divisaRender}/>
                            </EuiFormRow>
                        </EuiFlexItem>
                        <EuiFlexItem className="txt-ajuste-expatriados">
                            <EuiFormRow label={showLabel?'Total':''} hasEmptyLabelSpace={showLabel===true?false:true}>
                                <EuiFieldText isLoading={isLoading} compressed readOnly 
                                tabIndex={-1} value={isLoading?'0.00':toDecimalString(costoTotal)} append={divisaRender}/>
                            </EuiFormRow>
                        </EuiFlexItem>

                        <EuiFlexItem className="txt-facturable-ajuste-expatriados">
                            <EuiFormRow label={showLabel?'Facturable':''} hasEmptyLabelSpace={showLabel===true?false:true}> 
                                <EuiFieldText compressed tabIndex={0} 
                                value={isLoading?'0.00':ajusteFacturable} append={divisaRender}
                                isLoading={isLoading}
                                readOnly={!enabled}
                                onBlur={(e:any)=>{onBlurFacturable(e)}}
                                pattern="^-?(\d+)(((.|,)\d+)+)?"
                                onChange={(e:any)=>onChangeFacturable(e.target.value)}/>
                            </EuiFormRow>
                        </EuiFlexItem>
                        <EuiFlexItem className="txt-nofacturable-ajuste-expatriados">
                            <EuiFormRow label={showLabel?'No Facturable':''} hasEmptyLabelSpace={showLabel===true?false:true}>
                                <EuiFieldText isLoading={isLoading} compressed readOnly 
                                tabIndex={-1} value={isLoading?'0.00':ajusteNoFacturable} append={divisaRender}/>
                            </EuiFormRow>
                        </EuiFlexItem>
                </EuiFlexGroup> 
            </EuiFlexItem>
                {getErrorAjusteFacturable}
                {getErrorFormato}
        </EuiFlexGroup>
    )
})

